import { useCallback, useEffect, useState } from 'react';

/** Seconds a new sign-up code waits for, as the API enforces it. */
export const SIGNUP_CODE_RESEND_SECONDS = 60;

/**
 * Seconds left before a new code may be asked for, counted from the last
 * sending. `restart` is called on each successful sending.
 */
export function useResendCooldown(seconds = SIGNUP_CODE_RESEND_SECONDS) {
  const [sentAt, setSentAt] = useState(() => Date.now());
  const [now, setNow] = useState(() => Date.now());

  const remaining = Math.max(0, Math.ceil((sentAt + seconds * 1000 - now) / 1000));

  useEffect(() => {
    if (remaining === 0) return;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [remaining]);

  const restart = useCallback(() => {
    const at = Date.now();
    setSentAt(at);
    setNow(at);
  }, []);

  return { remaining, restart };
}
